"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundaryComponent = void 0;
const React = __importStar(require("react"));
const react_error_boundary_1 = require("react-error-boundary");
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const errorBoundaryComponent_module_css_1 = __importDefault(require("./errorBoundaryComponent.module.css"));
const ErrorFallback = ({ error, resetErrorBoundary }) => {
    const smallButton = React.createElement(antd_1.Button, { onClick: resetErrorBoundary, icon: React.createElement(icons_1.WarningOutlined, null), size: "small" }, "Try again");
    const isDevelopmentEnvironment = process.env.NODE_ENV === "development";
    return React.createElement(antd_1.Row, { className: errorBoundaryComponent_module_css_1.default.errorBoundaryComponentSmall },
        React.createElement(antd_1.Col, null, isDevelopmentEnvironment ?
            React.createElement(antd_1.Tooltip, { title: React.createElement(React.Fragment, null,
                    React.createElement("pre", null, error.stack)) }, smallButton) :
            smallButton));
};
const errorHandler = (error, info) => {
    console.log("ErrorBoundaryComponent: ", error, info);
};
const ErrorBoundaryComponent = ({ children }) => {
    return React.createElement(react_error_boundary_1.ErrorBoundary, { FallbackComponent: ErrorFallback, onError: errorHandler }, children);
};
exports.ErrorBoundaryComponent = ErrorBoundaryComponent;
